import type { HookAPI as ModalHookAPI } from "antd/es/modal/useModal";

let modalApi: ModalHookAPI | null = null;

export const setModalApi = (api: ModalHookAPI): void => {
  modalApi = api;
};

export const getModalApi = (): ModalHookAPI | null => modalApi;
